import { oliveIconTokens } from '@ds/tokens'

const breadcrumb = {
  separatorColor: oliveIconTokens.iconColorDefault,
} as const

export default breadcrumb
